// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","443":"about"}[chunkId] || chunkId) + "." + {"12":"e5cb0b98","177":"41453877","443":"4ce16d23","824":"4d39aa82"}[chunkId] + ".js";
};